// extracted by mini-css-extract-plugin
export var colorSquare = "_pw-0";
export var danger = "_pw-5";
export var lightPink = "_pw-8";
export var neutralBlue = "_pw-7";
export var neutralYellow = "_pw-6";
export var normal = "_pw-1";
export var primary = "_pw-2";
export var primaryLight = "_pw-3";
export var solidBlack = "_pw-g";
export var solidGreen = "_pw-b";
export var solidLightBlue = "_pw-d";
export var solidNavy = "_pw-c";
export var solidOrange = "_pw-f";
export var solidPink = "_pw-e";
export var solidRed = "_pw-9";
export var solidYellow = "_pw-a";
export var success = "_pw-4";